import axios from 'axios'

export const state = {
  printers: [],
}

export const getters = {
  getPrinters() {
    return state.printers
  },
}

export const mutations = {
  SET_PRINTER(state, printers) {
    state.printers = printers
  },
}

export const actions = {
  createPrinters({
    commit,
    state
  }, {
    printerDetails
  }) {
    return axios
      .post(`v1/printer`, printerDetails)
      .then(response => {
        return response
      })
  },
  getAllPrinters({
    commit
  }, outletId) {
    return axios.get(`v1/printer/${outletId}`).then(response => {
      return response
    })
  },



  setAllPrinters({
    commit,
    state
  }, printers) {
    commit('SET_PRINTER', printers)
  },

  updatePrinters({
    commit,
    state
  }, {
    printerDetails
  }) {
    return axios
      .put(`v1/printer/update`, printerDetails)
      .then(response => {
        return response
      })
  },
}
